import {ApiSlice} from "@/store/ApiSlice";
import RESTAPIConfig from "@/config/RESTAPIConfig";
import {ActiveFileExtensionsListInterface} from "./Interfaces/ActiveFileExtensionsListInterface";

const restApiConfig = new RESTAPIConfig();

export const ActiveFileExtensionsListApiSlice = ApiSlice.injectEndpoints({
    endpoints: builder => ({
        getActiveFileExtensions: builder.query<ActiveFileExtensionsListInterface, void>({
            query: () => ({
                url: restApiConfig.baseUrl + restApiConfig.apiPrefixV2 + restApiConfig.fileExtensionsActiveList(),
            }),
            providesTags: ["FetchedData", "ActiveFileExtensions"]
        })
    })
});

export const {useGetActiveFileExtensionsQuery} = ActiveFileExtensionsListApiSlice;
